import { useContext } from 'react'

import { ContentFiltersContext } from './content-filters.context'
import type { IContentFiltersContext } from './content-filters.types'

export const useContentFilters = (): IContentFiltersContext => useContext(ContentFiltersContext)
